export const checkTagExistence = (tagName: string, tags: readonly string[]): boolean => {
    return tags.some((tag) => tag.toLowerCase() === tagName.toLocaleLowerCase());
};
